// export const API_URL = "http://localhost:5000/api";
// export const PUBLIC_PATH = "http://localhost:3010";

// export const API_URL = "https://beta.lcdprize.com/api";
// export const PUBLIC_PATH = "https://beta.lcdprize.com";

// export const GEOPLUGIN_URL = "https://get.geojs.io/v1/ip/country.json";
// export const COUNTRY_PARAMETER = "country";
// export const LANGUAGE_CODE = "en";

export const ADVERTISEMENT_POSTION = {
    "position-1": 1,
    'position-2': 2,
    "position-3": 3,
    "position-4": 4,
    "position-5": 5,
    "position-6": 6
}

export const ADVERTISEMENT_PAGE = {
    "myprofile": 1,
    'team': 2,
    "player": 3,
    "main-advertise": 4
}

export const ADVERTISEMENT_TYPE = {
    "banner": 1,
    "logo": 2,
    "video": 3
}

const NORMAL_USER_TYPE = 0;
const STORE_USER_TYPE = 1;
const SPONSER_USER_TYPE = 2;
const ADMIN_USER_TYPE = 3;

export const NORMAL_USER_ACCESS = [NORMAL_USER_TYPE];
export const STORE_USER_ACCESS = [STORE_USER_TYPE];
export const SPONSER_USER_ACCESS = [SPONSER_USER_TYPE];
export const ADMIN_USER_ACCESS = [ADMIN_USER_TYPE];
export const NORMAL_ADMIN_ACCESS = [NORMAL_USER_TYPE, ADMIN_USER_TYPE];
export const STORE_ADMIN_ACCESS = [STORE_USER_TYPE, ADMIN_USER_TYPE];
export const SPONSER_ADMIN_ACCESS = [SPONSER_USER_TYPE, ADMIN_USER_TYPE];
